export default "__VITE_ASSET__BoP8ZsyJ__"